import Vue from 'vue'
import 'mutationobserver-shim'
import './Utils/fliter'
import App from './App.vue'
import router from './router'
import store from './store'
import Raphael from 'raphael/raphael'
import './plugins'
import './registerServiceWorker'
import AlgoliaComponents from 'vue-instantsearch'
import i18n from './i18n'
import moment from 'moment';
import 'vue2-datepicker/index.css';

//https://apexcharts.com/docs/vue-charts/
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)


Vue.filter('dateConvertYYYYMMDD', function(value){
  if(value){
    return moment(value).format('YYYY-MM-DD');
  }

});
Vue.filter('dateConvertDDMMYYYY', function(value){
  if(value){
    return moment(value).format('DD-MM-YYYY');
  }

});
Vue.filter('dateConvertDDMMYYYYTime', function(value){
  return moment(value).format('DD-MM-YYYY hh:mm A');
  });

  Vue.filter('reverse', function(value) {
    // slice to make a copy of array, then reverse the copy
    return value.slice().reverse();
  });

Vue.filter('ActiveBoolean', function(value){
  if(value === 1){
      return 'Active';
  }else{
      return 'In-active';
  }
});

Vue.filter('YesOrNoBoolean', function(value){
  if(value === 1){
      return 'Yes';
  }else{
      return 'No';
  }
});
// Get Decimal places
Vue.filter('with-decimal', function(value) {
  if((value !== '') && (value != null) && (value !== undefined)){
    const num1 = Number(value);

    return num1.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }
});
Vue.filter('with-YesNo', function(value) {
  if(value == 1) {
    return "Yes"
  }else if(value == 0){
    return "No"
  }else{
    return "N/A"
  }
});

// Vue.component('pagination', require('laravel-vue-pagination'));


Vue.filter('text-50', function(string) {
    return string.substring(0, 50);
});

// https://vuelidate.js.org/#sub-installation
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)


// https://www.vue2editor.com/guide.html#installation
import Vue2Editor from "vue2-editor";
Vue.use(Vue2Editor);

// Vue-multiselect
import Multiselect from 'vue-multiselect';
Vue.component('multiselect', Multiselect);

// Vue Video Embed component for Vue.js
// https://vuejsexamples.com/vue-video-embed-component-for-vue-js/
import Embed from 'v-video-embed'
Vue.use(Embed);

//https://github.com/sampotts/plyr#events
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';
Vue.use(VuePlyr, {
  plyr: {}
})

//Calendly inline widget begin
import VueCalendly from 'vue-calendly';
Vue.use(VueCalendly);



// https://randomcodetips.com/vue-html-to-paper/
import VueHtmlToPaper from 'vue-html-to-paper';
const options = {
  name: '_blank',
  specs: [
    // 'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://cdn.jsdelivr.net/npm/bootstrap@4.6.1/dist/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
    'public/report.css',
  ],
  timeout: 1000, // default timeout before the print window appears
  autoClose: true, // if false, the window will not close after printing
  windowTitle: window.document.title, // override the window title
}


Vue.use(VueHtmlToPaper, options);


global.Raphael = Raphael

Vue.use(AlgoliaComponents)

Vue.config.productionTip = false

let vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

window.vm = vm
